import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '日本樱花', to: '/category/japan-sakura' },
    { label: '武汉樱花', to: '/category/wuhan-sakura' },
    { label: '北京樱花', to: '/category/beijing-sakura' },
    { label: '樱花飘落', to: '/category/falling-sakura' },
    { label: '延时摄影', to: '/category/timelapse-sakura' },
    { label: '高清素材', to: '/category/hd-footage' },
  ],
  pages: [
    { label: '关于我们', to: '/about' },
    { label: '隐私政策', to: '/about' },
    { label: '使用条款', to: '/about' },
    { label: '联系我们', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-lg font-heading font-bold text-foreground-900 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-flower-line text-primary-500 text-lg"></i>
              </span>
              <span>樱花视频</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              唯美樱花视频素材与观赏指南平台。记录每一帧飘落之美，为创作者和赏花爱好者提供最优质的樱花视频内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-categories" className="cursor-pointer">视频分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-pages" className="cursor-pointer">更多页面</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.pages.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#footer-contact" className="cursor-pointer">关注我们</a>
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-500 mt-4">
              邮箱：contact@nlafv.cn
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 mt-8 border-t border-background-200/60">
          <p className="text-xs text-foreground-500">
            &copy; 2026 樱花视频 SakuraVideo. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400 mt-2 sm:mt-0">
            本网站所有视频素材仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}